// セッション中のみ有効な揮発性の高い値をページ全体で共有したい場合に使用します。
export default class AppTempolaly {
  // preloadを有効化します。
  // ただし、インデックス外から飛んできた場合や、一度インデックスページを閲覧した場合はスキップします。
  public static requestPreload: boolean = true;
}
